let Message = {
	//版本号
	version: "1.0.5",
	backgroundDownload: "正在后台下载",
	noUpdate: "您当前已是最新版本",
	sellerAgreement: "请先同意卖家协议",
	/*-----Toast------*/
	//微信分享的提示
	invalidSharingService: "无效的分享服务",
	authorized: "已授权",
	unauthorized: "未授权",
	authenticationFailure: "认证授权失败",
	getSharingServiceListSuccessfully: "获取分享服务列表成功",
	getSharingServiceListFailed: "获取分享服务列表失败",
	shareSuccess: "分享成功",
	shareFailure: "未安装微信",
	shareWeiboFailure: "分享失败",
	shareNotSupportedInWeb: "暂不支持网页分享",

	//关于复制的提示
	copySuccess: "复制成功",
	copyFailure: "复制失败",

	//login 提示
	phoneEmpty: "手机号码不能为空",
	phoneError: "手机号码有误",
	verificationCodeSent: "验证消息已发出，请注意查收",
	codeEmpty: "验证码不能为空",
	codeError: "验证码输入有误",
	passwordEmpty: "密码不能为空",
	passwordTooShort: "密码长度过短，必须6位以上",
	passwordNotMatch: "两次密码输入不一致",

	//动态评论提示
	commentEmpty: "评论内容不能为空",
	commentTooLong: "评论不能超过500个汉字",
	commentSuccess: "评论成功",

	//出价买/立刻买/出价卖/立刻卖 提示
	bidPriceFormat: "价格必须为10的倍数",
	addressNotSelected: "请选择收货地址",
	buyOwnProductWarning: "不能购买自己出售的商品",
	duplicateBid: "你已出过此价格，请重新修改出价",
	askingPriceChanged: "当前出售价格发生变化，请重新出价",
	sellOwnProductWarning: "不能出售自己求购的商品",
	bidPriceLessThanZero: "出价不能小于或者等于0",
	biddingPriceChanged: "当前求购价格发生变化，请重新出价",
	noSale: "当前暂无出售",//可以在求购页面出价求购商品哦
	searchProduct: "请输入您想要搜索的商品",
	noSellerCoupon: "不能选择卖家优惠券哦！",
	noBuyerCoupon: "不能选择买家优惠券哦！",
	biddingPriceEmpty: "请输入出价",

	//支付提示
	failedToGetPaymentChannel: "获取支付通道失败",
	paymentError: "支付过程发生异常",
	paymentFailure: "支付失败",
	bidSucceed : "出价成功",
	sellSucceed: "出售成功，等待买家付款",
	buySucceed: "购买成功，等待卖家发货",

	//收藏提示
	favorite: "收藏成功！",
	cancelFavorite: "取消收藏成功！",

	//用户编辑提示
	displayName: "昵称只支持汉字、英文、下划线和数字",
	displayNameTooLong: "昵称不可大于8个汉字或16个英文",
	changeAvatarNotSupportedInWeb: "暂不支持网页版修改头像",
	selectSex: "请选择性别",

	//上传图片提示
	imageTooBig: "图片大小不能超过10M",
	uploadFailure: "上传失败",
	imageTypeError: "图片格式有误",
	uploadSuccess: "上传成功",
	fileReadError: "读取文件信息错误",
	uploadNotSupportedInWeb: "暂不支持网页版上传",

	//设置提示
	regexPhone: "请输入正确的手机号",
	addressEmpty: "所在区域不能为空",
	provinceEmpty: "所在省/市不能为空",
	cityEmpty: "所在市/区不能为空",
	areaEmpty: "所在区/县不能为空",
	detailedAddressEmpty: '详细地址不能为空',
	detailedAddressTooLong: "输入的详细地址过长",
	saveSuccess: "保存成功",
	userFeedbackTypeEmpty: "类型不能为空",
	titleEmpty: "标题不能为空",
	detailsEmpty: "请描述具体详细问题",
	submitSuccess: "提交成功",
	submitFailure: "提交失败",
	usernameEmpty: "用户名不能为空",
	usernameTooLong: "用户名过长",
	paymentAccountError: "支付账号输入有误",

	//卖家申请添加商品
	productInfoMissing: "请完善商品资料",
	submitAddProductRequestSuccess: "提交成功，等待审核",
	messageAndImageEmpty: "图片与内容均不能为空",
	messageTooLong: "内容字数超过限制",
	shareInvitationCodeError: "当前用户无法生成邀请码，如有问题请联系平台客服",

	//运单号提示
	trackingNumberError: "您输入的运单号不正确",

	//清除缓存
	clearStorageSuccess: "清除成功",
	accountCancellation: "您的账户注销申请已提交，我们会在5个工作日内完成审核",

	//实名认证
	IDCardEmpty: "身份证号不能为空",
	realNameError: "真实姓名输入有误",
	IDCardError: "身份证号输入有误",
	followSuccess: "关注成功",
	cancelFollowSuccess: "取消关注成功",
	invitationCodeSubmitSuccess:"邀请码提交成功",

	//消息通知
	oneMessage: "你有1条消息",
	youHave: "你有",
	multipleMessages: "条消息",
	bindSuccess: "绑定成功",
	unbindSuccess: "解绑成功",
	referenceError: "服务器繁忙请稍后再试",

	//收款账户
	accountNumberError: "账号有误",
	accountNumberEmpty: "账号不能为空",
	realNameEmpty: "姓名不能为空",
	authorizedLoginSuccess: "授权登录成功",
	weChatLogging: "微信登录中...",
	weiboLogging: "微博登录中...",

	//黑名单
	addBlacklist: "已拉黑，可以在隐私设置—黑名单设置里查看",
	deleteBlacklist: "移出黑名单",
	selectProduct: "请选择一件您喜欢的商品",
	couponUnavailable: "该商品不能使用此优惠券",



	/*-----MessageBox-----*/
	deletePostTitle: "删除动态",
	confirmDeletePost: "确定要删除这一组动态吗?",
	deleteSearchHistoryTitle: "删除浏览历史",
	confirmDeleteSearchHistory: "确定要删除浏览历史吗?",
	cancelBidTitle: "取消出价",
	confirmCancelBid: "确定要取消出价吗?",
	reportCommentTitle: "举报该评论",
	confirmReportComment: "确定要举报该评论吗?",
	clearStorageTitle: "清除缓存",
	confirmClearStorage: "确定要清除缓存吗?",
	logoutTitle: "退出登录",
	confirmLogout: "确定要退出登录吗?",
	deleteAddressTitle: "删除地址",
	confirmDeleteAddress: "确定要删除地址吗",
	addBlackTitleFirst: "将\"",
	addBlackTitleLast: "\"拉黑",
	addBlackContent: "对方将无法评论你的动态，对方不会收到被拉黑的通知",
	accountCancellationTitle: "账户注销确认",
	accountCancellationContent: "提交申请后，将不能再进行购买、出售等交易行为，账户注销后，您在平台的所有权益也将一并失效",
	cancelFollowTitle: "取消关注",
	cancelFollowContent: "确定取消关注？"
};
export default Message;



// WEBPACK FOOTER //
// ./src/components/js/message.js